.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

.card {
  flex: 1 1 calc(33.333% - 8px);
  min-width: 240px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 20px 16px;
  background: var(--surface);
  border-radius: var(--radius);
  animation: fadeUp 0.4s ease both;
  animation-delay: calc(var(--i, 0) * 55ms);
}

.label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--soft);
  text-align: center;
}

/* Two competitors side by side, split by a hairline divider. */
.duel {
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  align-items: start;
  gap: 12px;
}

/* Three or four would each get a quarter of a card, and the numbers are the
   widest thing in it — so they stack into rows instead: handle on the left,
   figure on the right. */
.stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.divider {
  align-self: stretch;
  background: var(--border);
}

.side {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  text-align: center;
}

.stack .side {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: baseline;
  gap: 2px 10px;
  text-align: right;
}

.stack .name {
  text-align: left;
}

.stack .value {
  font-size: clamp(1.25rem, 3.5vw, 1.55rem);
}

.stack .sub {
  grid-column: 2;
  min-height: 0;
}

.name {
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.name { color: var(--accent); }

.value {
  font-family: var(--font-display);
  font-size: clamp(1.6rem, 4.5vw, 2rem);
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1.05;
  letter-spacing: -0.01em;
  color: var(--text);
}

/* Winner pops in its accent colour; loser recedes so the eye lands on the
   winning number first. */
.side.win .value { color: var(--accent); }
.side.lose .value { color: var(--soft); opacity: 0.7; }

.sub {
  font-size: 0.82rem;
  color: var(--muted);
  min-height: 16px;
}

.verdict {
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid var(--border);
  font-size: 0.88rem;
  font-weight: 700;
  text-align: center;
  /* Handles are user-supplied and can be long — wrap rather than overflow. */
  overflow-wrap: anywhere;
}

.verdict.win { color: var(--accent); }
.verdict.tie { color: var(--muted); font-weight: 600; }

@media (max-width: 520px) {
  /* One card per row on phones — full width, larger numbers to scan. */
  .card {
    flex-basis: 100%;
    min-width: 0;
  }

  .value {
    font-size: 2rem;
  }

  .duel {
    gap: 16px;
  }
}
